<template>
    <b-button @click="onClick" v-b-tooltip="title" :variant="variant" v-if="dropdownList.length === 0" :disabled="loading">
        <span v-if="loading" class="d-flex align-items-center justify-content-center">
            <b-spinner small/>
        </span>
        <span v-else>
            <b-icon :icon="icon" />
            <span v-if="title && showTitle">{{ title }}</span>
        </span>
    </b-button>
    <b-dropdown v-else variant="info" :text="title">
        <b-dropdown-item
                v-for="(item, i) in dropdownList"
                :key="i"
                @click="onChoiceClick(item)">{{ item.text }}</b-dropdown-item>
    </b-dropdown>
</template>

<script>
    import EventBus from "@/bus";

    export default {
        name: "DataTableAction",
        props: {
            name: { type: String },
            icon: { type: String },
            title: { type: String },
            variant: {type: String, default: 'transparent'},
            showTitle: { type: Boolean, default: false },
            dropdownList: { type: Array, default: () => { return [] } },
            emittedEvent: { type: String },
        },
        data() {
            return {
                loading: false
            }
        },
        computed: {
            startEvent() { return this.emittedEvent + '-start' },
            finishEvent() { return this.emittedEvent + '-finish' }
        },
        methods: {
            onClick() {
                this.$emit(this.emittedEvent, { name: this.name });
            },
            onChoiceClick(item) {
                this.$emit(this.emittedEvent, item);
            }
        },
        mounted() {
            const vm = this;
            EventBus.$on(vm.startEvent, () => { vm.loading = true })
            EventBus.$on(vm.finishEvent, () => { vm.loading = false })
        }
    }
</script>

<style scoped>

</style>